// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** SettingPacks *******************************************************************
const INDEX_SETTING_PACKS_SUCCESS = "INDEX_SETTING_PACKS_SUCCESS";
const SHOW_SETTING_PACK_SUCCESS = "SHOW_SETTING_PACK_SUCCESS";
const STORE_SETTING_PACK_SUCCESS = "STORE_SETTING_PACK_SUCCESS";
const UPDATE_SETTING_PACK_SUCCESS = "UPDATE_SETTING_PACK_SUCCESS";
const DESTROY_SETTING_PACK_SUCCESS = "DESTROY_SETTING_PACK_SUCCESS";
// ******************************************************************** settings **********************************************************************
const INDEX_SETTINGS_SUCCESS = "INDEX_SETTINGS_SUCCESS";
const SHOW_SETTING_SUCCESS = "SHOW_SETTING_SUCCESS";
const STORE_SETTING_SUCCESS = "STORE_SETTING_SUCCESS";
const UPDATE_SETTING_SUCCESS = "UPDATE_SETTING_SUCCESS";
const DESTROY_SETTING_SUCCESS = "DESTROY_SETTING_SUCCESS";

const INDEX_SETTINGS_FORM_SUCCESS = "INDEX_SETTINGS_FORM_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** SettingPacks *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_SETTING_PACKS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_SETTING_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_SETTING_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_SETTING_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_SETTING_PACK_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************** settings **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSettingsSuccess(payload) {
  return {
    type: INDEX_SETTINGS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSettingSuccess(payload) {
  return {
    type: SHOW_SETTING_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSettingSuccess(payload) {
  return {
    type: STORE_SETTING_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSettingSuccess(payload) {
  return {
    type: UPDATE_SETTING_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySettingSuccess(payload) {
  return {
    type: DESTROY_SETTING_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showRule(payload) {
  return {
    type: INDEX_SETTINGS_FORM_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** Settings *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/setting-packs", { params })
      .then((r) => {
        dispatch(_indexSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Number} setting
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(setting, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/setting-packs/${setting}`, { params })
      .then((r) => {
        dispatch(_showSuccess(r));
        callback(r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showForm(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/settings`, { params })
      .then((res) => {
        dispatch(_showRule(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.settings",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.setting.Adding New Setting")
    );

    api
      .post("/setting-packs", { data })
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.setting.New Setting Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.setting",
            "خطا در ارسال اطلاعات",
            app.translate(
              "routes.home.attendance.setting.Adding New Setting Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} setting
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(setting, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.setting.Updating Setting")
    );

    api
      .put(`/setting-packs/${setting}`, { data })
      .then((r) => {
        dispatch(_updateSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.setting.Setting Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.setting",
            "عملیات بروزرسانی با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.setting.Updating Setting Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} setting
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(setting, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.setting.Removing Setting")
    );

    api
      .delete(`/setting-packs/${setting}`)
      .then((r) => {
        dispatch(_destroySuccess(setting));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.setting.Setting Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.setting",
            "عملیات حذف با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.setting.Removing Setting Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptySettingPacks() {
  return _indexSuccess({ data: { settingPacks: [] }, meta: {} });
}

/**
 *
 * @return {Function}
 */
export function emptyRule() {
  return _showRule({ data: { rule: {} } });
}

// ******************************************************************** settings **********************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexSettings(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/settings", { params })
      .then((r) => {
        dispatch(_indexSettingsSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} setting
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showSetting(setting, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/setting-packs/settings/${setting}`, { params })
      .then((res) => {
        dispatch(_showSettingSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeSetting(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.setting.Adding New Setting")
    );

    api
      .post(`/settings`, { data })
      .then((r) => {
        dispatch(_storeSettingSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.setting.New Setting Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.setting",
            "خطا در ارسال اطلاعات",
            app.translate(
              "routes.home.attendance.setting.Adding New Setting Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} setting
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateSetting(setting, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.setting.Updating Setting")
    );

    api
      .put(`/settings/${setting}`, { data })
      .then((r) => {
        dispatch(_updateSettingSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.setting.Setting Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.setting",
            "عملیات بروزرسانی با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.setting.Updating Setting Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} setting
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroySetting(setting, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.setting.Removing Setting")
    );

    api
      .delete(`/settings/${setting}`)
      .then((r) => {
        dispatch(_destroySettingSuccess(setting));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.setting.Setting Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.setting",
            "عملیات حذف با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.setting.Removing Setting Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySettings() {
  return _indexSettingsSuccess({ data: { settings: {} }, meta: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySetting() {
  return _showSettingSuccess({ data: { setting: {} } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    settingPacks: [],
    settingPack: {},
    settings: [],
    setting: {},
    metaSettings: {},
  },
  action
) {
  let settingPacks;
  let settingPack;
  let _index;

  switch (action.type) {
    case INDEX_SETTING_PACKS_SUCCESS:
      return Object.assign({}, state, {
        settingPacks: action.payload.data.settingPacks,
        metaSettings: action.payload.meta,
      });
    case SHOW_SETTING_PACK_SUCCESS:
      return Object.assign({}, state, {
        settingPack: action.payload.settingPack,
      });
    case STORE_SETTING_PACK_SUCCESS:
      settingPacks = app._.clone(state.settingPacks);
      settingPacks.push(action.payload);
      return Object.assign({}, state, {
        settingPack: action.payload,
        settingPacks,
      });
    case UPDATE_SETTING_PACK_SUCCESS:
      settingPacks = app._.clone(state.settingPacks);
      settingPack = app._.clone(state.settingPack);
      _index = settingPacks.findIndex(
        (_setting) => _setting.id === action.payload.id
      );
      settingPacks[_index] = action.payload;
      settingPack.name = action.payload.name;
      settingPack.description = action.payload.description;
      return Object.assign({}, state, {
        settingPack,
        settingPacks,
      });
    case DESTROY_SETTING_PACK_SUCCESS:
      settingPacks = app._.clone(state.settingPacks);
      _index = settingPacks.findIndex(
        (_setting) => _setting.id === action.payload
      );
      settingPacks.splice(_index, 1);
      return Object.assign({}, state, {
        settingPacks,
        settingPack: null,
        setting: null,
      });
    case INDEX_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        settings: action.payload.data.settings,
        metaSettings: action.payload.meta,
      });
    case SHOW_SETTING_SUCCESS:
      return Object.assign({}, state, {
        setting: action.payload.setting,
      });
    case STORE_SETTING_SUCCESS:
      settingPack = app._.cloneDeep(state.settingPack);
      let _rules = [];
      _rules.push(action.payload);
      if (!app._.isEmpty(settingPack.settings)) {
        _rules.push(...settingPack.settings);
      }
      settingPack.settings = _rules;
      return Object.assign({}, state, {
        setting: action.payload,
        settingPack,
      });
    case UPDATE_SETTING_SUCCESS:
      settingPack = app._.cloneDeep(state.settingPack);
      _index = settingPack.settings.findIndex(
        (_setting) => _setting.id === action.payload.id
      );
      settingPack.settings[_index] = action.payload;
      return Object.assign({}, state, {
        setting: action.payload,
        settingPack,
      });
    case DESTROY_SETTING_SUCCESS:
      settingPack = app._.cloneDeep(state.settingPack);
      _index = settingPack.settings.findIndex(
        (_setting) => _setting.id === action.payload
      );
      settingPack.settings.splice(_index, 1);
      return Object.assign({}, state, {
        settingPack,
      });
    case INDEX_SETTINGS_FORM_SUCCESS:
      return Object.assign({}, state, {
        settings: action.payload.settings,
      });
    default:
      return state;
  }
}
